import { Injectable } from '@angular/core';
import { filterNil } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

import { OrganizationPropertyName } from 'organization/model/organization-property-name';
import { UserApplicationPort } from 'user/port/user-application.port';

@Injectable()
export class CoachProfileInformationController {
	public showMeetingButton$: Observable<boolean>;

	constructor(private _userApplicationPort: UserApplicationPort) {
		this._initObservables();
	}

	private _initObservables() {
		this.showMeetingButton$ = this._userApplicationPort.observeSessionUser().pipe(
			filterNil(),
			switchMap((user) => user.organization$.pipe(map((org) => ({ org, user })))),
			map(
				({ user, org }) =>
					user.isCoachee &&
					(!org ||
						org.isPropertyTrue(
							OrganizationPropertyName.COACHING_BOOTH_MEETING_ENABLED,
							true
						))
			),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}
}
